import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Info } from 'lucide-react'

/**
 * PAY-2 (T149-085/086): the note pointing at Settings to enable another
 * payment method for RECORDING a payment (which stays tied to the methods
 * enabled in Settings, owner decision A). Always visible wherever a method
 * is chosen (the invoice payment dialog, quick pay, wizard step 8), not only
 * when nothing is enabled: a user who can't find a method needs to know
 * where to add one either way.
 *
 * One component, reused everywhere the note appears, so the copy and the
 * i18n keys can't drift between call sites.
 */
export function PaymentMethodEnableNote() {
  const { t } = useTranslation('invoices')

  return (
    <p className="text-xs text-base-content/60 flex items-center gap-1">
      <Info className="w-3.5 h-3.5 flex-shrink-0" aria-hidden="true" />
      <span>
        {t('payment.enable_method_hint')}{' '}
        <Link to="/settings?tab=payments" className="link link-primary">
          {t('payment.enable_method_link')}
        </Link>
      </span>
    </p>
  )
}
